import {JourneyActionRunner} from "./JourneyActionRunner";
import {ConditionEvaluator, parseConditionNode} from "./ConditionEvaluator";
import {NOOP_FUNCTION} from "../../../../stem-core/src/base/Utils.js";
import {merchantFunctionModule} from "../../merchant-state/MerchantFunctionModule.js";

/*
UserJourneyDescription = {
    id: Number,
    alias: String,
    // The precondition needs to be true in order for the journey to be possible when selecting by weight
    precondition: UJNodeDescription | undefined,
    // Pick the largest priority, and on a tie use the weight
    // TODO move into the entry
    priority: number | undefined,
    weight: number | undefined,

    // Now see if we actually should run it
    condition: UJNodeDescription | undefined,
    throttle: UserJourneyThrottle | undefined,

    action: UserJourneyAction,
}
*/

export function evaluateJourneyPrecondition(journey) {
    if (!journey.precondition) {
        return true;
    }
    const condition = parseConditionNode(journey, journey.precondition, NOOP_FUNCTION);
    const result = condition.evaluate();
    condition.cleanup();
    if (result == null) {
        merchantFunctionModule.handleException(
            new Error(`Precondition for journey '${journey.alias}' could not be evaluated synchronously.`),
            journey.alias,
        );
        return false;
    }
    return result;
}

export function evaluateConditionAndRun(journey) {
    const runner = new JourneyActionRunner(journey);
    const {condition} = journey.options;
    if (!condition) {
        // Journeys that don't have a condition are simply executed once,
        // then never heard from again.
        runner.runAction();
        return null;
    }

    // TODO @branch I'm not sure running the journey's action every time the condition
    //  re-evaluates to true is correct in all cases, think about this some more.
    // TODO @branch @Mihai by default journeys should have a single blocker
    return new ConditionEvaluator(journey, condition, (result) => {
        if (result) {
            runner.runAction();
        }
    });
}
